/** Node and browser ICU versions use different Swiss grouping apostrophes. */
export function normalizeNumberGrouping(text: string): string {
  return text.replace(/(\d)['\u02bc](?=\d)/g, "$1\u2019");
}
